'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* responsiveFacets */
define(['app', '$window', '$console', 'accordionWidget', 'accessibleModalHelper', 'accessibilityFocusHelper'], function (app, $window, $console, accordion, accessibleModalHelper, accessibilityFocusHelper) {
  return function () {
    var _breakpoint = 900;
    var _noScroll = 'responsiveFacets_noScroll';
    var _containerTransitioned = 'responsiveFacets_container-transitioned';
    var _errorDuration = 3 * 1000;

    var _select = {
      checkbox: '.responsiveFacets_sectionItemCheckbox',
      mobileSectionHead: '.responsiveFacets_sectionHead-mobile',
      sectionContainer: '.responsiveFacets_sectionContainer',
      sectionItem: '.responsiveFacets_sectionItem',
      sectionClear: '.responsiveFacets_sectionClear',
      sectionTitle: '.responsiveFacets_sectionTitle',
      selection: '.responsiveFacets_selection',
      clearAll: '.responsiveFacets_clearAll',
      refine: '.responsiveFacets_refine',
      container: '.responsiveFacets_container',
      saveContainer: '.responsiveFacets_saveContainer',
      save: '.responsiveFacets_save',
      sectionBackArrow: '.responsiveFacets_sectionBackArrow',
      menuClose: '.responsiveFacets_menuClose',
      error: '.responsiveFacets_error',
      checkboxDivs: '.responsiveFacets_sectionItemValue',
      mobileRefineTitle: '#responsive-facets-title',
      mobileSectionTitle: '.responsiveFacets_mobileSectionTitle',
      sectionInteractiveElements: 'button, a, .responsiveFacets_sectionItemValue',
      mobileSectionInteractiveElements: 'div.responsiveFacets_sectionItemValue, button:not(.responsiveFacets_sectionHead)',
      sectionContent: '.responsiveFacets_sectionContent'
    };

    var _attr = {
      key: 'data-facet-key',
      value: 'data-facet-value',
      show: 'data-show',
      selected: 'data-selected',
      ariaHidden: 'aria-hidden'
    };

    var _channels = {
      update: 'responsiveProductListPage/update'
    };

    var _accordionConfig = {
      isOpen: true,
      selectors: {
        title: '.responsiveFacets_sectionHead',
        content: '.responsiveFacets_sectionContent',
        focusableElements: '[role="checkbox"]'
      },
      offset: 1,
      tracking: {
        enabled: true,
        channel: 'responsiveFacets'
      }
    };
    var _selectors = {
      fastTrackSwitch: '.fastTrack_onListPage',
      fastTrackSectionItem: '.responsiveFacets_sectionItem_fastTrack',
      fastTrackCheckbox: 'fastTrackCheckbox',
      fastTrackFacetCategory: 'fastTrackFacetCategory',
      fastTrackDeliverableFacet: 'fastDeliverableCountries'
    };
    var _elems = {
      items: [],
      sectionContainers: [],
      container: null,
      refine: null,
      save: null,
      checkboxes: [],
      sectionHeads: [],
      sectionTitles: [],
      selections: [],
      clearAll: null,
      backArrows: [],
      menuCloses: [],
      error: null
    };

    var _mobile = {
      show: false,
      section: -1
    };

    var comp = {
      element: null,
      changes: false,
      facets: [],
      // testing
      _elems: _elems,
      _mobile: _mobile,
      _attr: _attr,
      _channels: _channels,
      _noScroll: _noScroll,
      _breakpoint: _breakpoint
    };

    // To prevent IE 11 error log
    var blankChangeEvent = void 0;
    if (typeof Event === 'function') {
      blankChangeEvent = new Event('change');
    } else {
      blankChangeEvent = document.createEvent('Event');
      blankChangeEvent.initEvent('change', false, false);
    }
    // IE fix end

    /**
     * Init
     *
     * @param {HTMLElement} element
     */
    comp.init = function (element) {
      comp.element = element;
      comp.changes = false;
      _elems.fastTrackSwitch = document.querySelector(_selectors.fastTrackSwitch);
      _elems.items = element.querySelectorAll(_select.sectionItem);
      _elems.container = element.querySelector(_select.container);
      _elems.refine = element.querySelector(_select.refine);
      _elems.saveContainer = element.querySelector(_select.saveContainer);
      _elems.save = element.querySelector(_select.save);
      _elems.sectionContainers = element.querySelectorAll(_select.sectionContainer);
      _elems.checkboxes = element.querySelectorAll(_select.checkbox);
      _elems.sectionHeads = element.querySelectorAll(_select.mobileSectionHead);
      _elems.sectionTitles = element.querySelectorAll(_select.sectionTitle);
      _elems.selections = element.querySelectorAll(_select.selection);
      _elems.clearAll = element.querySelector(_select.clearAll);
      _elems.backArrows = element.querySelectorAll(_select.sectionBackArrow);
      _elems.menuCloses = element.querySelectorAll(_select.menuClose);
      _elems.error = element.querySelector(_select.error);
      _elems.mobileRefineTitle = element.querySelector(_select.mobileRefineTitle);
      _elems.checkboxDivs = element.querySelectorAll(_select.checkboxDivs);

      if (!_elems.container) {
        return;
      }

      _elems.allInteractiveElements = _elems.container.querySelectorAll(_select.sectionInteractiveElements);

      comp.build();
      comp.bind();
      comp.activate();

      // because this component is reinitialised when there's a change to the page,
      // we want to open/close the facets given the state it currently has
      if (_mobile.show) {
        comp.open();
      } else {
        // this removes the left-over noscroll class on body
        comp.close();
      }
    };

    /**
     * Builds facets and accordions.
     */
    comp.build = function () {
      // map each item to its facet value and filter empty values
      comp.facets = Array.from(_elems.items).map(function (item) {
        var checkbox = item.querySelector(_select.checkbox);

        if (!checkbox.checked) {
          return null;
        }

        var key = item.getAttribute(_attr.key);
        var value = item.getAttribute(_attr.value);

        return key + ':' + value;
      }).filter(function (f) {
        return f !== null;
      });

      // initialise accordions for sections without any selections
      _elems.sectionContainers.forEach(function (container, index) {
        if (container.getAttribute(_attr.selected) === 'true') {
          return;
        }

        // make a new object so each accordion has a different config
        var sectionTitle = _elems.sectionTitles[index].innerText;
        var config = Object.assign({}, _accordionConfig);

        config.tracking = Object.assign({}, config.tracking);
        config.tracking.extra = sectionTitle;

        container.componentObject = new accordion().init(container, config);
      });
    };

    /**
     * Binds event listeners to elements.
     */
    comp.bind = function () {
      var _this = this;

      _elems.checkboxes.forEach(function (c, i) {
        return c.addEventListener('change', comp.facetClick.bind(_this, i));
      });
      _elems.checkboxDivs.forEach(function (c, i) {
        return c.addEventListener('keypress', comp.facetKeyboardPress.bind(_this, i));
      });
      _elems.sectionHeads.forEach(function (h, i) {
        return h.addEventListener('click', comp.openSection.bind(_this, i));
      });

      _elems.selections.forEach(function (selection) {
        return selection.addEventListener('click', comp.clearSelectionListener);
      });
      _elems.backArrows.forEach(function (arrow) {
        return arrow.addEventListener('click', comp.back);
      });
      _elems.menuCloses.forEach(function (closeArrow) {
        return closeArrow.addEventListener('click', comp.close);
      });
      if (_elems.fastTrackSwitch) {
        _elems.fastTrackSwitch.addEventListener('change', comp.fastTrackSwitchChange);
      }
      if (_elems.clearAll) {
        _elems.clearAll.addEventListener('click', comp.clearAll);
      }

      $window.addEventListener('resize', comp.resize);
      _elems.save.addEventListener('click', comp.save);
      _elems.refine.addEventListener('click', comp.open);

      _elems.sectionContainers.forEach(function (container, index) {
        var clearEl = container.querySelector(_select.sectionClear);

        if (clearEl) {
          clearEl._index = index;
          clearEl.addEventListener('click', comp.clearSectionListener);
        }
      });
    };

    /**
     * Activate transition on the container.
     */
    comp.activate = function () {
      // has to be deffered so it applies after comp.open is called in comp.init
      $window.setImmediate(function () {
        _elems.container.classList.add(_containerTransitioned);
      });
    };

    /**
     * Opens mobile facets.
     */
    comp.open = function (ev) {
      _elems.container.setAttribute('role', 'dialog');

      $window.document.body.classList.add(_noScroll);
      _elems.container.setAttribute(_attr.show, 'true');

      // Enable Top Level Menu
      comp.setTopLevelMenuTabKeyboardAccess(true);
      // Disable All Child Level Menus
      comp.preventKeyboardAccessOnAllChildLinks();
      // Start modal focus control and set starting element to title
      comp.accessibleModalHelper = new accessibleModalHelper(_elems.container, comp.close, _elems.mobileRefineTitle);

      // only track if the action is initiated by user
      // i.e. it has an event parameter
      if (ev) {
        app.publish('tracking/record', 'responsiveFacets', 'open', 'mobile facets');
      }

      _mobile.show = true;
    };

    /**
     * Closes mobile facets.
     */
    comp.close = function () {
      // Enable elements for desktop
      accessibilityFocusHelper.enableElements(_elems.allInteractiveElements);

      $window.document.body.classList.remove(_noScroll);
      _elems.container.setAttribute(_attr.show, 'false');

      // desktop cannot close the facets
      // but comp.close is still called even if it's desktop
      if ($window.document.documentElement.clientWidth < _breakpoint) {
        app.publish('tracking/record', 'responsiveFacets', 'close', 'mobile facets');
      }

      // want to clear changes
      comp.changes = 0;

      if (_mobile.section !== -1) {
        _elems.sectionContainers[_mobile.section].setAttribute(_attr.show, 'false');
      }

      _mobile.show = false;

      if (comp.accessibleModalHelper) {
        comp.accessibleModalHelper.close();
        delete comp.accessibleModalHelper;
      }
    };

    comp.setTopLevelMenuTabKeyboardAccess = function (keyboardAccessible) {
      var elementsToUpdate = [].concat(_toConsumableArray(_elems.container.querySelectorAll('.responsiveFacets_head > button')), _toConsumableArray(_elems.container.querySelectorAll('.responsiveFacets_selectionContainer > button')), _toConsumableArray(_elems.container.querySelectorAll('.responsiveFacets_section > button')));
      return keyboardAccessible ? accessibilityFocusHelper.enableElements(elementsToUpdate) : accessibilityFocusHelper.disableElements(elementsToUpdate);
    };

    comp.preventKeyboardAccessOnAllChildLinks = function () {
      // IE/EDGE Friendly flatmap alternative to array.prototype.flatMap
      var flatMapPolyfill = function flatMapPolyfill(f, xs) {
        return xs.map(f).reduce(function (x, y) {
          return x.concat(y);
        }, []);
      };

      _elems.container.querySelectorAll(_select.sectionContent).forEach(function (element) {
        return element.removeAttribute('tabindex');
      });

      _elems.container.querySelectorAll(_select.mobileSectionTitle).forEach(function (title) {
        return title.setAttribute(_attr.ariaHidden, 'true');
      });
      var allChildLinks = flatMapPolyfill(function (section) {
        return [].concat(_toConsumableArray(section.querySelectorAll(_select.sectionInteractiveElements))).map(function (element) {
          return element;
        });
      }, [].concat(_toConsumableArray(_elems.sectionContainers)));
      accessibilityFocusHelper.disableElements(allChildLinks);
    };

    /**
     * Saves changes and exits facets.
     */
    comp.save = function () {
      if (!comp.changes) {
        // exit when there are no changes to be made
        comp.close(true);
      } else {
        _mobile.section = -1;
        _mobile.show = false;

        comp.update(true);
      }
    };

    /**
     * Clears all facets.
     */
    comp.clearAll = function () {
      comp.checkAndUpdateFastTrackCookie();
      comp.facets = [];
      comp.changes = true;

      app.publish('tracking/record', 'responsiveFacets', 'remove', 'all facets');

      comp.update(true);
    };

    /**
     * Return to first mobile page.
     */
    comp.back = function () {
      var sectionTitle = _elems.sectionTitles[_mobile.section].innerText;

      app.publish('tracking/record', 'responsiveFacets', 'close', 'mobile facets section', sectionTitle);

      comp.preventKeyboardAccessOnAllChildLinks();
      _elems.sectionContainers[_mobile.section].setAttribute(_attr.show, 'false');

      // Enable Top Level Menu
      comp.setTopLevelMenuTabKeyboardAccess(true);
      // Reload modal focus control and set starting element to title
      comp.accessibleModalHelper && comp.accessibleModalHelper.reload(_elems.container, _elems.mobileRefineTitle);

      _mobile.section = -1;

      comp.update(true);
    };

    /**
     * Opens a mobile facet section.
     *
     * @param {number} index
     */
    comp.openSection = function (index) {
      var sectionTitle = _elems.sectionTitles[index].innerText;

      app.publish('tracking/record', 'responsiveFacets', 'open', 'mobile facets section', sectionTitle);

      if (_mobile.section !== -1) {
        _elems.sectionContainers[_mobile.section].setAttribute(_attr.show, 'false');
      }

      _elems.sectionTitles[index].setAttribute('aria-expanded', 'true');
      _elems.sectionContainers[index].setAttribute(_attr.show, 'true');
      _mobile.section = index;

      // Disable Top Level Menu
      comp.setTopLevelMenuTabKeyboardAccess(false);
      // Make title available to screen reader
      var mobileSectionTitle = _elems.sectionContainers[index].querySelector(_select.mobileSectionTitle);
      mobileSectionTitle && mobileSectionTitle.removeAttribute('aria-hidden');
      // Enable child section
      accessibilityFocusHelper.enableElements(_elems.sectionContainers[index].querySelectorAll(_select.mobileSectionInteractiveElements));
      // Reload modal focus control and set starting element to title
      comp.accessibleModalHelper && comp.accessibleModalHelper.reload(_elems.container, _elems.sectionContainers[index].querySelector(_select.mobileSectionTitle));
    };

    /**
     * Resize handler
     */
    comp.resize = function () {
      comp.update();
    };

    /**
     * Facet click handler
     *
     * @param {number} index
     */
    comp.facetClick = function (index) {
      comp.checkAndUpdateFastTrackCookie(index, null);
      var item = _elems.items[index];

      var key = item.getAttribute(_attr.key);
      var value = item.getAttribute(_attr.value);

      var facet = key + ':' + value;

      app.publish('tracking/record', 'responsiveFacets', 'add', facet);

      if (_elems.checkboxes[index].checked) {
        comp.facets.push(facet);
      } else {
        comp.facets = comp.facets.filter(function (f) {
          return f !== facet;
        });
      }

      comp.changes = true;

      if (item.classList.contains('fastTrack')) {
        comp.update(true);
      } else {
        comp.update();
      }
    };

    /**
     * Facet keyboard press handler
     *
     * @param {object} e
     * @param {int} i
     */
    comp.facetKeyboardPress = function (i, e) {
      if (e.key === ' ') {
        e.preventDefault();
        var hiddenCheckbox = _elems.checkboxes[i];
        hiddenCheckbox.checked = !hiddenCheckbox.checked;
        hiddenCheckbox.dispatchEvent(blankChangeEvent);
      }
    };

    /**
     * Clear section click handler
     *
     * @param {MouseEvent} ev
     */
    comp.clearSectionListener = function (ev) {
      var index = ev.currentTarget._index;

      if (!_elems.sectionContainers[index]) {
        $console.error('Cannot clear non-existing section at index ' + index + '.');
        return;
      }
      comp.checkAndUpdateFastTrackCookie(null, index);
      var sectionTitle = _elems.sectionTitles[index].innerText;

      app.publish('tracking/record', 'responsiveFacets', 'remove', 'facet group', sectionTitle);

      var section = _elems.sectionContainers[index];
      var facets = section.querySelectorAll(_select.sectionItem);

      var toRemove = Array.from(facets).map(function (facet) {
        var key = facet.getAttribute(_attr.key);
        var value = facet.getAttribute(_attr.value);

        return key + ':' + value;
      });

      comp.facets = comp.facets.filter(function (f) {
        return !toRemove.includes(f);
      });
      comp.changes = true;

      comp.update(true);
    };

    /**
     * Clear selection click handler
     *
     * @param {MouseEvent} ev
     */
    comp.clearSelectionListener = function (ev) {
      var selection = ev.currentTarget;

      var key = selection.getAttribute(_attr.key);
      var value = selection.getAttribute(_attr.value);
      var facet = key + ':' + value;

      app.publish('tracking/record', 'responsiveFacets', 'remove', facet);
      if (facet && facet.includes(_selectors.fastTrackDeliverableFacet)) {
        comp.setCookie('fastTrackSwitchCookie', 'disableSwitch');
      }
      comp.facets = comp.facets.filter(function (f) {
        return f !== facet;
      });
      comp.changes = true;

      comp.update(true);
    };

    /**
     * Sends the facets to the product list page.
     *
     * Mobile updates are only being sent if the 'force' parameter is set to true.
     *
     * @param {boolean} force forces the facets to be update (mobile only)
     */
    comp.update = function (force) {
      // don' update if it's mobile and non-forcing
      if (!force && $window.document.documentElement.clientWidth < _breakpoint) {
        return;
      }

      /**
       * If no longer in mobile mode, make sure that all elements are accessible to the keyboard
       */
      if ($window.document.documentElement.clientWidth > _breakpoint) {
        _mobile.show && comp.close();
      }

      if (comp.changes) {
        app.publish(_channels.update, { facetFilters: comp.facets.join('|') });
        _elems.error.setAttribute(_attr.show, 'false');
      }
    };

    /**
     * Displays an alert at the bottom of the screen.
     */
    comp.error = function () {
      _elems.error.setAttribute(_attr.show, 'true');
      _elems.error.removeAttribute(_attr.ariaHidden);
      _elems.error.style.bottom = _elems.saveContainer.offsetHeight + 'px';

      $window.setTimeout(function () {
        _elems.error.setAttribute(_attr.show, 'false');
        _elems.error.setAttribute(_attr.ariaHidden, 'true');
      }, _errorDuration);

      app.publish('tracking/record', 'responsiveFacets', 'error', 'new page load');
    };

    comp.fastTrackSwitchChange = function () {
      var index = parseInt(_elems.fastTrackSwitch.getAttribute('data-index'));
      var switchState = _elems.fastTrackSwitch.getAttribute('data-switch-enabled');
      _elems.checkboxes[index].checked = switchState === 'false';
      comp.facetClick(index);
    };

    comp.checkAndUpdateFastTrackCookie = function (facetIndex, categoryIndex) {
      var index = 0;
      var fastTrackFacetExists = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _elems.checkboxes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var checkbox = _step.value;

          if (checkbox.classList.contains(_selectors.fastTrackCheckbox)) {
            fastTrackFacetExists = true;
            break;
          }
          index++;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (fastTrackFacetExists) {
        if (facetIndex !== null && facetIndex === index) {
          comp.setCookie('fastTrackSwitchCookie', _elems.checkboxes[index].checked ? 'enableSwitch' : 'disableSwitch');
        } else if (categoryIndex) {
          var sectionIndex = 0;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = _elems.sectionContainers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var sectionContainer = _step2.value;

              if (sectionContainer.classList.contains(_selectors.fastTrackFacetCategory)) {
                break;
              }
              sectionIndex++;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (sectionIndex === categoryIndex) {
            comp.setCookie('fastTrackSwitchCookie', 'disableSwitch');
          }
        } else if (_elems.checkboxes[index].checked) {
          comp.setCookie('fastTrackSwitchCookie', 'disableSwitch');
        }
      }
    };

    comp.setCookie = function (name, value) {
      var path = '/';
      var expirationDate = new Date();
      expirationDate.setFullYear(expirationDate.getFullYear() + 1);
      document.cookie = name + '=' + value + '; expires=' + expirationDate.toUTCString() + '; path=' + path;
    };
    return comp;
  };
});
//# sourceMappingURL=responsiveFacets.js.map
